import { render } from "./AddTunnelView.vue?vue&type=template&id=67545042"
import script from "./AddTunnelView.vue?vue&type=script&lang=js"
export * from "./AddTunnelView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__